import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Add, Delete, Edit } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LinkIcon from "@mui/icons-material/Link";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
  DialogActions,
  Grid,
  TextField,
  Paper,
  CircularProgress,
  ButtonBase,
} from "@mui/material";
import { useFieldArray, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import CAUTIONICON from "../../assets/icons/caution.webp";
import GOODICON from "../../assets/icons/good.webp";
import GOODICON1 from "../../assets/icons/GOODICON1.webp";
import MARKERICON from "../../assets/icons/marker.webp";
import WARNINGICON from "../../assets/icons/warning.webp";
import EDITICON from "../../assets/icons/edit.png";

import CsvIcon from "../../assets/icons/csv-icon.svg?react";
import * as XLSX from "xlsx";

import { CustomSlider, ResponsiveTabs } from "../../common";
import {
  createAssessmentForm as createAssessmentFormAction,
  deleteAssessmentForm as deleteAssessmentFormAction,
  duplicateAssessmentForm as duplicateAssessmentFormAction,
  getCompanyAssessmentForm as getCompanyAssessmentFormAction,
  inviteCandidatesForInterview as inviteCandidatesForInterviewAction,
  inviteCandidatesForInterviewViaLink as inviteCandidatesForInterviewViaLinkAction,
  updateAssessmentForm as updateAssessmentFormAction,
} from "../../redux/slices/assessmentsSlice";
import SelectLanguage from "../../common/SelectLanguage";
import Dropzone from "react-dropzone";
import CSV from "./InviteCandidatesModal/InviteBulk/CSV";
import { enqueueSnackbar } from "notistack";
import PreAssessmentForm from "../../common/AssessmentForms/PreAssessmentForm";
import AlreadyCreatedForms from "../../common/AssessmentForms/AlreadyCreatedForms";

const SuggestedMarker = ({ suggestedValue }) => (
  <Box
    sx={{
      position: "absolute",
      top: "18px",
      left: `${suggestedValue}%`,
      pointerEvents: "none",
      transform: "translateX(-50%)",
    }}
  >
    <Box component="img" src={MARKERICON} height={30} />
  </Box>
);

const validationSchema = yup.object().shape({
  participants: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Name is required"),
      email: yup.string().email("Invalid email").required("Email is required"),
    })
  ),
});

const InviteViaAssessmentModal = ({
  open,
  onClose,
  interviewValue,
  setInterviewValue,
  passingCriteriaSet,
  setPassingCriteriaSet,
  tabValue,
  setTabValue,
  selectedAssessmentId,
  user,
  inviteCandidatesForInterview,
  inviteCandidatesForInterviewViaLink,
  copied,
  setCopied,
  linkGenerated,
  setLinkGenerated,
  interviewId,
  setInterviewId,
  flag,
  files,
  setFiles,
  CsvTableData,
  setCsvTableData,
  getCompanyAssessmentForm,
  updateAssessmentForm,
  deleteAssessmentForm,
  duplicateAssessmentForm,
  createAssessmentForm,
}) => {
  const navigate = useNavigate();
  const [showLanguageSelectModal, setShowLanguageSelectModal] = useState(false);
  const [languagesForInterview, setLangaugesForInterview] = useState([]);
  const [suggestedValue] = useState(70);
  const [loading, setLoading] = useState(false);
  const [loaderForForm, setLoaderForForm] = useState(false);
  const [uploadedFileType, setUploadedFileType] = useState(null);

  // New state for Pre-assessment form
  const [showPreAssessmentForm, setShowPreAssessmentForm] = useState(false);
  const [
    showAlreadyCreatedAssessmentForm,
    setShowAlreadyCreatedAssessmentForm,
  ] = useState(false);

  const [preAssessmentData, setPreAssessmentData] = useState(null);
  const [selectedPreAssessmentId, setSelectedPreAssessmentId] = useState(null);

  const [preAssessmentFormAttached, setPreAssessmentFormAttached] =
    useState(false);
  const [assessmentForms, setAssessmentForms] = useState([]);
  const [assessmentFormsCount, setAssessmentFormsCount] = useState();

  const getAlreadyCreatedForms = async () => {
    try {
      const data = await getCompanyAssessmentForm({
        company_id: user?.company_id,
        skip: 1,
        take: 100,
      }).unwrap();

      console.log("data", data);

      setAssessmentFormsCount(data?.count);
      setAssessmentForms(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAlreadyCreatedForms();
  }, []);

  // const hasFiles = Array.isArray(files) && files.length > 0;

  const onCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(
      `https://test-interview.getgeek.ai/screenForm/:1?initial_interview_id=${interviewId}`
    );
    setTimeout(() => setCopied(false), 2000);
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    trigger,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      participants: [{ name: "", email: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "participants",
  });

  const handleOpenDialog = () => {
    setShowAlreadyCreatedAssessmentForm(true);
  };

  const handleCloseDialog = () => {
    setShowAlreadyCreatedAssessmentForm(false);
  };

  const handleCreateNew = async () => {
    setShowPreAssessmentForm(true);
  };

  const handleEditForm = async (formId) => {
    try {
      const form = assessmentForms?.find((f) => f.id === formId);
      const dataToEdit = {
        ...form?.form_data,
        form_name: form?.form_name,
      };

      setPreAssessmentData(dataToEdit);
      setSelectedPreAssessmentId(formId);
      handleOpenPreAssessmentForm();
    } catch (error) {
      console.error("Error editing form:", error);
    }
  };

  const handleDuplicateForm = async (formId) => {
    try {
      const form = assessmentForms?.find((f) => f.id === formId);
      const dupForm = await duplicateAssessmentForm(formId).unwrap();
      setAssessmentForms([...assessmentForms, dupForm]);
      setSelectedPreAssessmentId(null);
      setPreAssessmentFormAttached(false);
    } catch (error) {
      console.error("Error duplicating form:", error);
    }
  };

  const handleDeleteForm = async (formId) => {
    try {
      const delForm = await deleteAssessmentForm(formId).unwrap();

      const updatedForms = assessmentForms?.filter((f) => f.id !== formId);
      setAssessmentForms(updatedForms);
      setSelectedPreAssessmentId(null);
      setPreAssessmentFormAttached(false);

      if (updatedForms.length === 0) {
        handleCloseDialog();
      }
    } catch (error) {
      console.error("Error deleting form:", error);
    }
  };

  const handleUseForm = async (formId) => {
    try {
      const form = assessmentForms?.find((f) => f.id === formId);
      setSelectedPreAssessmentId(formId);
      setShowAlreadyCreatedAssessmentForm(false);
      setPreAssessmentFormAttached(true);
      setLinkGenerated(false);
    } catch (error) {
      console.error("Error using form:", error);
    }
  };

  const handleSavePreAssessment = async (data) => {
    try {
      setLoaderForForm(true);
      console.log("Pre-assessment data saved:", data);
      if (selectedPreAssessmentId) {
        const existingForm = assessmentForms.find(
          (form) => form.id === selectedPreAssessmentId
        );

        // Serialize the data to avoid reference inequality issues
        const isUnchanged =
          existingForm?.form_name === data?.form_name &&
          JSON.stringify(existingForm?.form_data?.questions) ===
            JSON.stringify(data?.questions) &&
          existingForm?.form_data?.useAI === data?.useAI;

        if (isUnchanged) {
          console.log("No changes detected. Skipping update.");
          setLoaderForForm(false);
          setSelectedPreAssessmentId(null);
          setShowPreAssessmentForm(false);
          setPreAssessmentFormAttached(false);
          setPreAssessmentData(null);
          return;
        }

        const res = await updateAssessmentForm({
          id: selectedPreAssessmentId,
          form_name: data?.form_name,
          form_data: {
            questions: data?.questions,
            useAI: data?.useAI,
          },
        }).unwrap();
        // Update the specific form in assessmentForms
        setAssessmentForms((prevForms) =>
          prevForms?.map((form) =>
            form.id === selectedPreAssessmentId ? res : form
          )
        );
        setSelectedPreAssessmentId(null);
        setShowPreAssessmentForm(false);
        setPreAssessmentFormAttached(false);
        setPreAssessmentData(null);
      } else {
        const res = await createAssessmentForm({
          form_name: data?.form_name,
          form_data: {
            questions: data?.questions,
            useAI: data?.useAI,
          },
          company_id: user?.company_id,
        }).unwrap();
        setAssessmentForms([...assessmentForms, res]);
        setShowPreAssessmentForm(false);
        setLinkGenerated(false);
        handleOpenDialog();
      }
      setLoaderForForm(false);
    } catch (error) {
      console.error("Error saving pre-assessment:", error);
      setLoaderForForm(false);
    }
  };

  // Handle pre-assessment form
  const handleOpenPreAssessmentForm = () => {
    setShowPreAssessmentForm(true);
  };

  const marks = [
    { value: 0, label: "0%" },
    { value: 20, label: "20%" },
    { value: 40, label: "40%" },
    { value: 60, label: "60%" },
    { value: 80, label: "80%" },
    { value: 100, label: "100%" },
  ];

  // Function to handle the message text based on the value
  const getMessageForValue = (value) => {
    if (value < 40) {
      return "You're aiming pretty low! A criteria below 40% might allow too many candidates through. Consider raising it to focus on those better suited to the role.";
    }
    if (value >= 40 && value <= 60) {
      return "This range is a good starting point. You'll catch candidates with a decent match, but don’t be afraid to adjust based on your specific needs.";
    }

    if (value > 60 && value <= 90) {
      return "Now you're getting selective! This range helps ensure candidates closely match your requirements, giving you a solid pool of potentials.";
    }

    if (value > 90) {
      return "Whoa, setting the bar high, aren’t we? With criteria this tough, only a handful of rockstars might make it through. Are you sure you're setting this criteria?";
    }
    return "";
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const payload = {
        assessment_id: selectedAssessmentId,
        company_id: user?.company_id,
        candidates: data?.participants,
        passing_criteria: {
          interview_passing_criteria: interviewValue,
        },
        languages: languagesForInterview,
        flow: "3",
      };

      if (selectedPreAssessmentId) {
        payload.form_data_id = selectedPreAssessmentId;
      }

      await inviteCandidatesForInterview(payload);

      onClose();
      if (!flag) {
        navigate("/assessments/my-assessments");
      }

      reset({
        participants: [{ name: "", email: "" }],
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const generateLink = async (data) => {
    try {
      setLoading(true);

      const payload = {
        assessment_id: selectedAssessmentId,
        company_id: user?.company_id,
        passing_criteria: {
          interview_passing_criteria: interviewValue,
        },
        languages: languagesForInterview,
      };

      if (selectedPreAssessmentId) {
        payload.form_data_id = selectedPreAssessmentId;
      }

      const response = await inviteCandidatesForInterviewViaLink(
        payload
      ).unwrap();

      console.log("response from initial interview setup", response);

      if (response?.statusCode === 200) {
        setLinkGenerated(true);
        setLoading(false);
        setInterviewId(response?.data?.id);
        setShowPreAssessmentForm(false);
        setPreAssessmentFormAttached(false);
        setPreAssessmentData(null);
        setSelectedPreAssessmentId(null);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const makeColumns = (rawColumns) => {
    // Filter out empty and unwanted headers
    const filteredColumns = rawColumns?.filter(
      (column) => column && !column.startsWith("_")
    );

    return filteredColumns?.map((column) => {
      return { Header: column, accessor: column };
    });
  };

  const onCsvDrop = (acceptedFiles, data) => {
    const validFiles = acceptedFiles?.filter((file) => {
      const fileExtension = file?.name.toLowerCase().split(".").pop();
      return ["csv", "xls", "xlsx"].includes(fileExtension);
    });

    if (validFiles.length > 0) {
      const file = validFiles[0];
      const reader = new FileReader();

      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = parsedData[0];
        const rows = parsedData.slice(1).map((row) => {
          const rowData = {};
          headers.forEach((header, index) => {
            rowData[header] = row[index];
          });
          return rowData;
        });

        const parseFile = {
          data: rows,
          errors: [], // No errors for XLSX files
          meta: {
            aborted: false,
            cursor: file.size, // You may adjust this value according to your needs
            delimiter: ",", // Assuming the delimiter is comma
            fields: headers, // Assuming headers are consistent
            linebreak: "\n", // Assuming linebreak is newline
            truncated: false, // Assuming the file is not truncated
          },
        };

        console.log("LeadsImportStep1::> parseFile,", parseFile);
        setFiles(file);
        setUploadedFileType("CSV");
        setCsvTableData({
          data: parseFile.data,
          columns: makeColumns(parseFile.meta.fields),
        });
      };

      reader.readAsArrayBuffer(file);
    } else {
      if (data[0]?.errors[0]?.code === "file-too-large") {
        return enqueueSnackbar(data[0]?.errors[0]?.message, {
          autoHideDuration: 3000,
          variant: "warning",
        });
      }
      enqueueSnackbar(`File type not supported`, {
        autoHideDuration: 3000,
        variant: "warning",
      });
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          setShowLanguageSelectModal(false);
          setSelectedPreAssessmentId(null);
          setPreAssessmentFormAttached(false);
          onClose();
        }}
        sx={{
          "& .MuiDialog-paper": {
            margin: 0,
            width: { xs: "95vw", md: "60vw" },
            height: { xs: "95vh", md: "75vh" },
            overflow: "hidden",
            maxWidth: "none",
            maxHeight: "none",
            p: 2,
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Invite candidates</Typography>
            <IconButton
              onClick={() => {
                setShowLanguageSelectModal(false);
                setSelectedPreAssessmentId(null);
                setPreAssessmentFormAttached(false);
                onClose();
              }}
              size="small"
              sx={{ border: 1, borderColor: "#999" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          {passingCriteriaSet && !showLanguageSelectModal && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { md: "row", sm: "row", xs: "column" },
              }}
            >
              <Box width="50%">
                <ResponsiveTabs
                  tabData={tabs}
                  selectedTab={tabValue}
                  onChange={setTabValue}
                  fullWidth={false}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                {preAssessmentFormAttached ? (
                  <Button
                    onClick={handleOpenDialog}
                    startIcon={<img src={EDITICON} height={30} />}
                    variant="contained"
                    sx={{
                      bgcolor: "#5B6B77",
                      borderRadius: 10,
                      fontSize: 13,
                      "&:hover": {
                        bgcolor: "#5B6B77",
                      },
                    }}
                  >
                    Edit form
                  </Button>
                ) : (
                  <Button
                    variant="main"
                    sx={{
                      bgcolor: "purple.main",
                      fontSize: 13,
                      "&:hover": {
                        bgcolor: "#9048FB",
                      },
                    }}
                    onClick={() => {
                      if (assessmentForms?.length > 0) {
                        handleOpenDialog();
                      } else {
                        handleOpenPreAssessmentForm();
                      }
                    }}
                  >
                    Attach Pre-assessment form
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </DialogTitle>
        <DialogContent>
          {!passingCriteriaSet ? (
            <Box sx={{}}>
              <Typography variant="body1" color="text.secondary" my={2}>
                Set the passing criteria for resumes and interviews to find
                potential candidates based on your requirements.
              </Typography>
              <Typography variant="body1" color="text.secondary" mb={2}>
                You can set criteria ranging from a minimum of 20% to a maximum
                of 100% for both. This will be directly applied to the resume
                screening process and the interview process.
              </Typography>

              <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Interview passing criteria
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Candidates are considered passed when their resumes match at
                  least 60% of the given requirements
                </Typography>

                <Box
                  sx={{
                    px: 5,
                    borderRadius: 10,
                    position: "relative",
                    boxShadow: "0px 0px 20px 3px #0000000D",
                  }}
                >
                  <CustomSlider
                    value={interviewValue}
                    onChange={(_, newValue) => setInterviewValue(newValue)}
                    marks={marks}
                    min={20}
                    max={99}
                    sx={{ mt: 2 }}
                    valueLabelDisplay="auto"
                  />
                  <SuggestedMarker suggestedValue={suggestedValue} />
                </Box>
                {/* Show message below the slider */}
                {interviewValue ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mx: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        interviewValue < 40
                          ? WARNINGICON
                          : interviewValue >= 40 && interviewValue <= 60
                          ? GOODICON
                          : interviewValue > 60 && interviewValue <= 90
                          ? GOODICON1 // ✅ Assign GOODICON for this range
                          : interviewValue > 90
                          ? CAUTIONICON
                          : null
                      }
                      mt={2}
                      height={25}
                    />

                    <Typography
                      variant="body2"
                      color={
                        interviewValue < 40
                          ? "#FFB400"
                          : interviewValue >= 40 && interviewValue <= 60
                          ? "#0BC6CF"
                          : interviewValue > 60 && interviewValue <= 90
                          ? "#9048FB" // ✅ Assign #9048FB for this range
                          : interviewValue > 90
                          ? "#FF5B5B"
                          : "black"
                      }
                      sx={{ mt: 2, ml: 2 }}
                    >
                      {getMessageForValue(interviewValue)}
                    </Typography>
                  </Box>
                ) : null}
              </Box>
            </Box>
          ) : (
            <>
              {showLanguageSelectModal ? (
                <SelectLanguage
                  isModal={true}
                  setLangaugesForInterview={setLangaugesForInterview}
                />
              ) : (
                <>
                  {tabValue === "share_link" ? (
                    <Box
                      border={1}
                      px={4}
                      py={3}
                      borderColor="#CFCFCF"
                      borderRadius="10px"
                      overflow="auto"
                    >
                      <Typography fontWeight={600} fontSize="15px">
                        Invite via link
                      </Typography>
                      <Box
                        mt={3}
                        bgcolor="#FAFAFA"
                        className="center"
                        flexDirection="column"
                        width={{ xs: "100%", md: "700px" }}
                        mx="auto"
                        p={4}
                        borderRadius="20px"
                        gap={2}
                      >
                        <Box
                          width="100%"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          gap={2}
                        >
                          <TextField
                            placeholder="https://interview.getgeek.ai/screenForm/:1?initial_interview_id=12345"
                            contentEditable={false}
                            disabled
                            sx={{ flex: 1 }}
                            slotProps={{ input: { sx: { color: "#999" } } }}
                          />
                          <Button
                            variant="main"
                            sx={{ py: 1.5 }}
                            onClick={() => {
                              if (linkGenerated) {
                                onCopy();
                              } else {
                                generateLink();
                              }
                            }}
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <CircularProgress
                                  size={18}
                                  sx={{ mr: 1, color: "white" }}
                                />
                                Generating...
                              </>
                            ) : copied ? (
                              <>
                                <CheckCircleIcon sx={{ mr: 1 }} /> Copied!
                              </>
                            ) : linkGenerated ? (
                              <>
                                <ContentCopyIcon sx={{ mr: 1 }} /> Copy Link
                              </>
                            ) : (
                              <>
                                <LinkIcon sx={{ mr: 1 }} /> Generate Link
                              </>
                            )}
                          </Button>
                        </Box>
                        <Box mt={2}>
                          <Typography
                            textAlign="left"
                            fontSize="15px"
                            fontWeight={700}
                          >
                            Info
                          </Typography>
                          <Typography fontSize="14px" color="#5B6F82" my={2}>
                            {
                              "With the 'Copy Link' feature, you can easily share an interview or assessment with candidates in your network. This is designed to help you reach the right people directly."
                            }
                          </Typography>
                          <Typography fontSize="14px" color="#5B6F82">
                            {
                              "Be mindful to share the link with only relevant candidates to ensure the interview experience remains meaningful for everyone involved."
                            }
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <>
                      {files && files?.length !== 0 ? (
                        <>
                          {uploadedFileType === "CSV" && (
                            <CSV
                              files={files}
                              setFiles={setFiles}
                              setTableData={setCsvTableData}
                              tableData={CsvTableData}
                              flag={flag}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {flag && (
                            <>
                              <Typography
                                color="#606060"
                                fontWeight={600}
                                fontFamily="Outfit"
                              >
                                Upload your file
                              </Typography>
                              <Box
                                display="flex"
                                gap={2}
                                flexDirection={{ xs: "column", md: "row" }}
                                alignItems="center"
                                mb={3}
                              >
                                <Dropzone
                                  accept={[".csv", ".xls", ".xlsx"]}
                                  onDrop={onCsvDrop}
                                  maxSize={5000000}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <ButtonBase
                                      {...getRootProps()}
                                      sx={{
                                        width: "100%",
                                        border: "1px dashed #885EFA",
                                        flexDirection: "column",
                                        gap: 1,
                                        height: "160px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "4px",
                                        bgcolor: "#F7F8F9",
                                        my: 2,
                                      }}
                                    >
                                      <input
                                        {...getInputProps()}
                                        accept={[".csv", ".xls", ".xlsx"]}
                                      />
                                      <CsvIcon />
                                      <Typography
                                        color="#151515"
                                        fontSize="16px"
                                        fontWeight={500}
                                        fontFamily="Outfit"
                                      >
                                        Upload CSV/XLSX
                                      </Typography>
                                      <Typography
                                        color="#999"
                                        fontSize="13px"
                                        fontFamily="Outfit"
                                      >
                                        One File at a time (size: 10MB)
                                      </Typography>
                                    </ButtonBase>
                                  )}
                                </Dropzone>
                              </Box>
                            </>
                          )}

                          <Paper
                            elevation={3}
                            sx={{
                              border: 1,
                              borderColor: "#CFCFCF",
                              p: 6,
                              maxWidth: "100%",
                              margin: "auto",
                            }}
                          >
                            {fields.map((field, index) => (
                              <Grid
                                container
                                key={field.id}
                                spacing={2}
                                sx={{ mb: 2 }}
                                alignItems="center"
                              >
                                <Grid item xs={12} sm={4}>
                                  <TextField
                                    {...register(`participants.${index}.name`)}
                                    label="Name"
                                    required
                                    fullWidth
                                    error={
                                      !!errors?.participants?.[index]?.name
                                    }
                                    helperText={
                                      errors?.participants?.[index]?.name
                                        ?.message
                                    }
                                    variant="outlined"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <TextField
                                    {...register(`participants.${index}.email`)}
                                    label="Email"
                                    required
                                    fullWidth
                                    error={
                                      !!errors?.participants?.[index]?.email
                                    }
                                    helperText={
                                      errors?.participants?.[index]?.email
                                        ?.message
                                    }
                                    variant="outlined"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                  {index > 0 ? (
                                    <IconButton
                                      onClick={() => remove(index)}
                                      color="error"
                                      aria-label="delete"
                                    >
                                      <Delete />
                                    </IconButton>
                                  ) : (
                                    <Button
                                      type="button"
                                      variant="main"
                                      startIcon={<Add />}
                                      onClick={() =>
                                        append({ name: "", email: "" })
                                      }
                                      size="small"
                                    >
                                      Add
                                    </Button>
                                  )}
                                </Grid>
                              </Grid>
                            ))}
                          </Paper>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          {!passingCriteriaSet && (
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="main"
                sx={{ bgcolor: "purple.main" }}
                onClick={() => {
                  setShowLanguageSelectModal(true);
                  setPassingCriteriaSet(true);
                }}
              >
                Confirm & continue
              </Button>
            </Box>
          )}

          {showLanguageSelectModal && (
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="main"
                sx={{ bgcolor: "purple.main" }}
                onClick={() => {
                  setShowLanguageSelectModal(false);
                  setPassingCriteriaSet(true);
                }}
              >
                Confirm & continue
              </Button>
            </Box>
          )}

          {tabValue === "email" && (
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="main"
                sx={{ py: 1, fontSize: "18px" }}
                // onClick={handleSubmit(onSubmit)}
                onClick={async () => {
                  if (CsvTableData?.data?.length > 0) {
                    const participantsFromCSV = CsvTableData.data.map((row) => {
                      const participant = {};

                      CsvTableData.columns.forEach((col) => {
                        participant[col.accessor] =
                          row[col.appendedValue || col.accessor];
                      });

                      return participant;
                    });

                    setValue("participants", participantsFromCSV);

                    const isValid = await trigger("participants");

                    if (!isValid) {
                      setValue("participants", [{ name: "", email: "" }]);
                      enqueueSnackbar(
                        "Invalid CSV data! Please make sure name and email are correct.",
                        { variant: "info" }
                      );
                      // Clear validation errors
                      clearErrors("participants");

                      return;
                    }
                  }

                  handleSubmit(onSubmit)(); // 👈 Validate and submit
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <CircularProgress
                      size={18}
                      sx={{ color: "#f1f1f1", mr: 1 }}
                    />
                    Sending Invite...
                  </>
                ) : (
                  "Send Invite"
                )}
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>

      {/* Pre-Assessment Form Modal */}
      {showPreAssessmentForm && (
        <PreAssessmentForm
          open={showPreAssessmentForm}
          setLoaderForForm={setLoaderForForm}
          loaderForForm={loaderForForm}
          onClose={() => {
            if (assessmentForms?.length > 0) {
              setShowAlreadyCreatedAssessmentForm(true);
            }
            setSelectedPreAssessmentId(null);
            setShowPreAssessmentForm(false);
            setPreAssessmentData(null);
          }}
          formAttached={preAssessmentFormAttached}
          onRemove={() => {
            setShowPreAssessmentForm(false);
            setPreAssessmentFormAttached(false);
            setPreAssessmentData(null);
            setSelectedPreAssessmentId(null);
          }}
          onSave={handleSavePreAssessment}
          initialData={preAssessmentData} // Pass the existing data
        />
      )}

      {showAlreadyCreatedAssessmentForm && assessmentForms && (
        <AlreadyCreatedForms
          open={showAlreadyCreatedAssessmentForm}
          onClose={handleCloseDialog}
          onCreateNew={handleCreateNew}
          existingForms={assessmentForms}
          onEditForm={handleEditForm}
          onDuplicateForm={handleDuplicateForm}
          onDeleteForm={handleDeleteForm}
          onUseForm={handleUseForm}
          selectedPreAssessmentId={selectedPreAssessmentId}
          onRemove={() => {
            setPreAssessmentFormAttached(false);
            setSelectedPreAssessmentId(null);
          }}
        />
      )}
    </>
  );
};

const tabs = [
  {
    title: "Share link",
    value: "share_link",
  },
  {
    title: "Invite by email",
    value: "email",
  },
];

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDipatchToProps = {
  inviteCandidatesForInterview: inviteCandidatesForInterviewAction,
  inviteCandidatesForInterviewViaLink:
    inviteCandidatesForInterviewViaLinkAction,
  getCompanyAssessmentForm: getCompanyAssessmentFormAction,
  updateAssessmentForm: updateAssessmentFormAction,
  deleteAssessmentForm: deleteAssessmentFormAction,
  duplicateAssessmentForm: duplicateAssessmentFormAction,
  createAssessmentForm: createAssessmentFormAction,
};

/* Export
  ============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(InviteViaAssessmentModal);
